let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4QfDA"), load("ffEVr"), load("1ZAFx"), load("18XFi"), load("h3G8d")]).then(() => parcelRequire('cul1e'));